import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Container from '@mui/material/Container';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../../i18n'; 

const Navbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(); // t is the translation function
  const [isAuthenticated, setIsAuthenticated] = useState(false); //user Logged In
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change language dynamically
  };

  // Check authentication status on mount, assuming the token is stored in local storage
  useEffect(() => {
    const token = localStorage.getItem('token');
    //const admin = localStorage.getItem('userRole');
    if (token) {
      setIsAuthenticated(true); // If token exists, user is authenticated
    }
  }, []);

  // Handle logout
    const handleLogout = () => {
      localStorage.removeItem('token'); // Remove token from localStorage
      localStorage.removeItem('userRole');
      setIsAuthenticated(false); // Update state to reflect the user is logged out
      navigate('/'); // Redirect user to the homepage
    };

  const [anchorEl, setAnchorEl] = useState(null); // State to control the dropdown menu visibility
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [discoverOpen, setDiscoverOpen] = useState(false);

  // Handle dropdown menu for desktop view
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Toggle drawer for mobile view
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  // Toggle Discover section in Drawer
  const handleDiscoverClick = () => {
    setDiscoverOpen(!discoverOpen);
  };

  // Discover Dropdown Menu for Desktop
  const renderDiscoverMenu = (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      disableScrollLock={true}
      sx={{
        '& .MuiPaper-root': { backgroundColor: '#722410', // Set the background color to red
        width: '190px'
        },
      }}
    >
      <MenuItem onClick={handleMenuClose} >
      <Link to='/discover'  style={{ textDecoration: 'none', color: 'white' }} >{t('navigation:allServices')}</Link>
      </MenuItem>
      <MenuItem onClick={handleMenuClose} style={{ textDecoration: 'none', color: 'white' }}>Coming soon</MenuItem>
      {/* <MenuItem onClick={handleMenuClose} style={{ textDecoration: 'none', color: 'white' }}>Flight</MenuItem> */}
    </Menu>
  );

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#722410' }}>
        <Container maxWidth="xl">
          <Toolbar>
            {/* Hamburger Menu for Mobile */}
            <IconButton
              edge="start"
              aria-label="menu"
              sx={{ mr: 2, display: { xs: 'flex', md: 'none' }, color: 'white' }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>

            {/* Website Logo and Title with Link */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src={'/Dreamer_new.png'} alt="Logo" style={{ width: 60, height: 60, marginRight: 8 }} />
              <Typography variant="h6" component="div" sx={{ color: 'white' }}>
                <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>Dreamer's Journey</Link>
              </Typography>
            </Box>

            {/* Desktop Navigations, moved to the right */}
            <Box sx={{ ml: 'auto', display: { xs: 'none', md: 'flex' } }}>
              {/* "Sign In" */}
              <Button sx={{ color: 'white','&:hover': {backgroundColor: '#982B1C'}}}>
                <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:home')}</Link>
              </Button>
              <Button sx={{ color: 'white','&:hover': {backgroundColor: '#982B1C'}}}>
                <Link to="/about" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:about')}</Link>
              </Button>
              <Button 
                sx={{ color: 'white','&:hover': {backgroundColor: '#982B1C'}}}
                onClick={handleMenuClick}
                aria-controls="discover-menu"
                aria-haspopup="true"
              >
                {t('navigation:discover')}
              </Button>
              <Button sx={{ color: 'white','&:hover': {backgroundColor: '#982B1C'}}}>
                <Link to="/support" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:contact')}</Link>
              </Button>
                {/* Conditional rendering for Login/Logout */}
              {!isAuthenticated ? (
                <Button sx={{ color: 'white', '&:hover': { backgroundColor: '#982B1C' } }}>
                  <Link to="/login" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:login')}</Link>
                </Button>
              ) : (
                <Button sx={{ color: 'white', '&:hover': { backgroundColor: '#982B1C' } }} onClick={handleLogout}>
                  {t('navigation:logout')}
                </Button>
              )}
                <Button variant="outlined" sx={{color: 'white','&:hover': {backgroundColor: '#982B1C'}}}  onClick={() => changeLanguage('en')}>EN</Button>
                <Button variant="outlined" sx={{color: 'white','&:hover': {backgroundColor: '#982B1C'}}}  onClick={() => changeLanguage('vi')}>VN</Button>
              {/* <button style={{ background: "#722410", color: 'white', border: '1px solid white',  cursor: 'pointer' }} onClick={() => changeLanguage('en')}>EN</button>
              <button style={{ background: "#722410", color: 'white', border: '1px solid white',  cursor: 'pointer' }} onClick={() => changeLanguage('vi')}>VN</button> */}
              {/* <div>
                {Object.keys(lngs).map((lng) => {
                  <Button sx={{ color: 'white' }}>
                    <Link to="/" style={{ textDecoration: 'none', color: 'white' }} type="submit" key={lng} onClick={() => i18n.changeLanguage(lng)} disabled ={i18n.resolvedLanguage === lng}>{lngs[lng].nativeName}</Link>
                  </Button>
                })}
              </div> */}

            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Render Discover Dropdown Menu for Desktop */}
      {renderDiscoverMenu}

      {/* Drawer for Mobile View */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        disableScrollLock={true} // Add this line
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#712d1c', // Red background
            color: 'white', 
          },
        }}
      >
        <Box sx={{ width: 250, overflow: 'hidden'  }}>
          {/* Add the website name at the top of the drawer */}
          <Box sx={{ display: 'flex', alignItems: 'center', padding: 2, textAlign: 'center' }}>
            <img src={'/Dreamer_new.png'} alt="Logo" style={{ width: 30, height: 30, marginRight: 8 }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>Dreamer's Journey</Link>
            </Typography>
          </Box>
          <Divider />
          <List>
            <ListItem>
              <ListItemText primary={<Link to="/" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:home')}</Link>} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText primary={<Link to="/about" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:about')}</Link>} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText primary={<Link to="/support" style={{ textDecoration: 'none', color: 'white' }}>{t('navigation:contact')}</Link>} />
            </ListItem>
            <Divider />
            <ListItem onClick={handleDiscoverClick}>
              <ListItemText primary={t('navigation:discover')} />
              {discoverOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={discoverOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem>
                  <Link to='/discover'  style={{ textDecoration: 'none', color: 'white' }}>
                    <ListItemText to='/discover' primary={t('navigation:allServices')}/>
                  </Link>
                </ListItem>
                <ListItem>
                  <ListItemText primary="Coming soon" />
                </ListItem>
                {/* <ListItem>
                  <ListItemText primary="Flight" />
                </ListItem> */}
              </List>
            </Collapse>
          </List>
          <Divider />
          {!isAuthenticated ? (
              <ListItem>
                <Link to="/login"  style={{ textDecoration: 'none', color: 'white' }}>
                  <ListItemText primary={t('navigation:login')} />
                </Link>
              </ListItem>
            ) : (
              <ListItem onClick={handleLogout}>
                  <ListItemText primary={t('navigation:logout')} />
              </ListItem>
          )}
          <Divider />
          <ListItem>
            <ListItemText primary={t('navigation:language')} />
          </ListItem>
          <Button variant="outlined" sx={{color: 'white','&:hover': {backgroundColor: '#982B1C'}}}  onClick={() => changeLanguage('en')}>EN</Button>
          <Button variant="outlined" sx={{color: 'white','&:hover': {backgroundColor: '#982B1C'}}}  onClick={() => changeLanguage('vi')}>VN</Button>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
